import { ZAP_PAGE_SIZE } from "@zapier/utils";

interface Input {
  page?: number;
  pageSize?: number;
  subfoldersOffset?: number;
}

export function useOrganizationZapsPagination({
  subfoldersOffset = 0,
  page = 1,
  pageSize = ZAP_PAGE_SIZE,
}: Input) {
  let limit = pageSize;
  // if the subfoldersOffset is greater than the current page size,
  // then the page should be empty
  if (subfoldersOffset >= pageSize * page) {
    limit = 0;
    // else, the limit should be the page size minus the subfoldersOffset,
  } else {
    limit = pageSize * page - subfoldersOffset;
    // limit should never be greater than the page size
    if (limit > pageSize) {
      limit = pageSize;
    }
  }

  // offset is the page number minus 1 times the page size minus the subfoldersOffset
  let offset = pageSize * (page - 1) - subfoldersOffset;
  // if the offset is negative, set it to 0
  offset = Math.max(offset, 0);

  return {
    offset,
    limit,
  };
}
